<div class="flex flex-col gap-4 p-4">
  <p-toast />
  <div>
    <h1 class="text-xl font-semibold text-slate-900">
      {{ 'price_policy.title' | translate }}
    </h1>
    <p class="mt-1 max-w-3xl text-sm text-slate-600">
      {{ 'price_policy.subtitle' | translate }}
    </p>
  </div>

  @if (loading()) {
    <p class="text-sm text-slate-600">{{ 'price_policy.loading' | translate }}</p>
  } @else if (error()) {
    <p class="text-sm text-red-700">{{ error()! | translate }}</p>
  } @else {
    <ul class="flex max-w-xl flex-col gap-3">
      @for (item of items(); track item.code) {
        <li class="flex items-center gap-3 rounded-md border border-slate-200 bg-white px-3 py-2">
          <input
            [id]="'price-policy-' + item.code"
            type="checkbox"
            class="h-4 w-4 cursor-pointer"
            [checked]="item.enabled"
            [disabled]="!canEdit() || saving()"
            (change)="setEnabled(item.code, $any($event.target).checked)"
          />
          <label class="cursor-pointer text-sm text-slate-900" [for]="'price-policy-' + item.code">
            {{ labelKey(item.code) | translate }}
          </label>
        </li>
      }
    </ul>
  }
</div>
